    import img01 from "../images/img-01.jpg";
    import img02 from "../images/img-02.jpg";
    import img03 from "../images/img-03.jpg";
    import img04 from "../images/img-04.jpg";
    import img05 from "../images/img-05.jpg";
    import img06 from "../images/img-06.jpg";
    import img07 from "../images/img-07.jpg";
    import img08 from "../images/img-08.jpg";
    import img09 from "../images/img-09.jpg";

    import ava01 from "../images/ava-01.png";
    import ava02 from "../images/ava-02.png";
    import ava03 from "../images/ava-03.png";
    import ava04 from "../images/ava-04.png";
    import ava05 from "../images/ava-05.png";
    import ava06 from "../images/ava-06.png";

    export const NFT__DATA = [
    {
        id: "01",
        title: "Travel Monkey Club",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img01,
        creator: "Trista Francis",
        creatorImg: ava01,
        currentBid: 5.89,
        categorey:"Art"
    },

    {
        id: "02",
        title: "Sir Lion Swag",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img02,
        creator: "Trista Francis",
        creatorImg: ava02,
        currentBid: 5.09,
        categorey:"domain-name"

    },

    {
        id: "03",
        title: "Civilian",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img03,
        creator: "Trista Francis",
        creatorImg: ava03,
        currentBid: 6.89,
        categorey:"Art"
    },

    {
        id: "04",
        title: "Guard",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img04,
        creator: "Trista Francis",
        creatorImg: ava04,
        currentBid: 7.89,
        categorey:"trending-card"
    },

    {
        id: "05",
        title: "Travel Monkey Club",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img05,
        creator: "Trista Francis",
        creatorImg: ava05,
        currentBid: 4.89,
        categorey:"Virtual-world"
    },

    {
        id: "06",
        title: "Sir Lion Swag",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img06,
        creator: "Trista Francis",
        creatorImg: ava06,
        currentBid: 4.99,
        categorey:"Music"
    },

    {
        id: "07",
        title: "Civilian",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img07,
        creator: "Trista Francis",
        creatorImg: ava03,
        currentBid: 5.89,
        categorey:"trending-card"
    },

    {
        id: "08",
        title: "Guard",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img08,
        creator: "Trista Francis",
        creatorImg: ava04,
        currentBid: 5.89,
        categorey:"Virtual-world"
        
    },

    {
        id: "09",
        title: "Travel Monkey Club",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
        imgUrl: img09,
        creator: "Trista Francis",
        creatorImg: ava05,
        currentBid: 5.89,
        categorey:"Music"
    },
    ];

    export const SELLER__DATA = [
    {
        id: "01",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
        sellerName: "Ryan Carder",
        sellerImg: ava01,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "02",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
        sellerName: "Trista Francis",
        sellerImg: ava02,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "03",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
        sellerName: "Ryan Carder",
        sellerImg: ava03,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "04",

        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

        sellerName: "Ryan Carder",
        sellerImg: ava04,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "05",

        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

        sellerName: "Trista Francis",
        sellerImg: ava05,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "06",

        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

        sellerName: "Trista Francis",
        sellerImg: ava06,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "01",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
        sellerName: "Ryan Carder",
        sellerImg: ava01,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "02",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
        sellerName: "Trista Francis",
        sellerImg: ava02,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "03",
        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
        sellerName: "Ryan Carder",
        sellerImg: ava03,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "04",

        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

        sellerName: "Ryan Carder",
        sellerImg: ava04,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "05",

        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

        sellerName: "Trista Francis",
        sellerImg: ava05,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },

    {
        id: "06",

        desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

        sellerName: "Trista Francis",
        sellerImg: ava06,
        currentBid: 5.89,
        fbUrl: "#",
        instaUrl: "#",
        twitUrl: "#",
    },
    ];